module.exports = __webpack_public_path__ + "img/Decoded_ir.c9126dda.png";